import React, { useState } from 'react';
interface EmptyListButtonProps {
  onRemoveAllEntries: Function;
}

const EmptyListButton : React.FC<EmptyListButtonProps> = ({ onRemoveAllEntries }) => {


  return (
    <button
      data-testid="empty-list-button"
      className={`grow bg-gray-300 hover:bg-red-500 hover:text-white font-bold py-1 px-2 rounded disabled:bg-gray-200 disabled:text-gray-400`}
      onClick={() => onRemoveAllEntries()}
    >Remove All</button>
  );
};

export default EmptyListButton;
